<template>
  <div id="change-password-modal" class="editor-modal">
      <h2>{{$t('password.new-pw-title')}}</h2>
		<form @submit="onSave">
			<custom-input ref="password"  :inputType="'password'"  v-model="model.oldPassword" :name="'oldPassword'" :label="$t('password.old-pw-label')" :placeholder="$t('password.old-pw-placeholder')" :invalidInput="!!invalidMsg.wrongOldPassword" :focusInputField="true"/>
			<div class="small text-danger" v-if="invalidMsg.wrongOldPassword">{{invalidMsg.wrongOldPassword}}</div>

			<custom-input :inputType="'password'"  v-model="model.newPassword" :name="'newPassword'" :label="$t('password.new-pw-label')" :placeholder="$t('password.new-pw-placeholder')" :invalidInput="passwordIsOk == false"/>
			<p class="small" style="margin-bottom:0;"> 
				{{$t('password-validation.requirements-title')}}
				<span  :class="!passwordMinLength ? 'text-danger' : 'text-success'">{{$t('password-validation.chars')}}</span>
				<span  :class="!passwordHasCapitalLetter ? 'text-danger' :'text-success'">{{$t('password-validation.uppercase')}}</span>
				<span  :class="!passwordHasNumber ? 'text-danger' : 'text-success' ">{{$t('password-validation.number')}}</span>
			</p>

			<custom-input :inputType="'password'"  v-model="model.newPasswordRepeat" :name="'newPasswordRepeat'" :label="$t('password.repeat-pw-label')" :placeholder="$t('password.repeat-pw-label')" :invalidInput="passwordsMatch == false"/>
			<div class="small text-danger" v-if="passwordsMatch == false">{{$t('password-validation.no-match')}}</div>
			<div class="footer">
				<button type="submit" class="btn btn-md btn-primary"  :disabled="!valid || saving" @click="onSave">{{saving ? $t('saving') + '..' : $t('save')}}</button>
				<button type="reset" class="btn btn-md btn-secondary" :disabled="saving" @click="$emit('close')">{{$t('cancel')}}</button>
			</div>
		</form>
	</div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import debounce from 'lodash/debounce'
export default {
   props: {
    onNew: Function,
	onClose: Function,
	onWrongPassword: Function
  },
	data () {
		return {
			model: {
				oldPassword: '',
				newPassword: '',
				newPasswordRepeat: ''
			},
			saving: false,
			success: true,
			invalidMsg: [],
			checkPasswordDebounce: debounce((password) => {
            this.checkPassword(password)
            }, 500),
			checkRepeatPasswordDebounce:  debounce((newPassword, newPasswordRepeat) => {
				this.checkRepeatPassword(newPassword, newPasswordRepeat)
				}, 500),
			passwordLength: 0,
			passwordMinLength: false,
			passwordHasCapitalLetter: false,
			passwordHasNumber: false,
			passwordIsOk: null,
			passwordsMatch: null

		}
	},
	computed: {
		valid () {
			return this.model.oldPassword && this.model.newPassword && this.model.newPassword.length > 5 && (this.model.newPassword === this.model.newPasswordRepeat) && this.passwordsMatch && this.passwordIsOk
		},
	},
	methods: {
		checkPassword(password){
            // Min requirements - 6 letters, 1 capital, 1 number
            this.passwordLength = password.length
            if(this.passwordLength >= 6){
                this.passwordMinLength = true
            }else this.passwordMinLength = false
            this.passwordHasCapitalLetter = /[A-Z]/.test(password)
            this.passwordHasNumber = /\d/.test(password)
            if(this.passwordMinLength && this.passwordHasCapitalLetter && this.passwordHasNumber){
                this.passwordIsOk = true
            }else {
              this.model.newPassword == '' ? this.passwordIsOk = null : this.passwordIsOk = false
            }
        },
        checkRepeatPassword(newPassword, repeatPassword){
            if(repeatPassword == '')this.passwordsMatch = null
            else{
                if (newPassword === repeatPassword) this.passwordsMatch = true
                else this.passwordsMatch = false
            }
        },
		async onSave(evt) {
			evt.preventDefault();
			this.onNew(this.model)
			try {
				this.saving = true
				this.success = await this.$store.dispatch('changePassword', this.model)
				if (this.success) this.$emit('close'),this.onClose()
				else this.saving = false
			} catch (e) {
				// error
				this.saving = false
				this.onWrongPassword()
				this.wrongPassword()			
				console.log(e)				
			}
		},

		validatePassword(value){
			if(this.model.newPassword.length < 5){
				this.invalidMsg['shortPassword'] = this.$t('password.short')
			}
			else{
				this.invalidMsg['shortPassword'] = null
			}
		},

		validatePasswordRepeat(value){
			if(this.model.newPassword != this.model.newPasswordRepeat){
				this.invalidMsg['noMatch'] = this.$t('password.no-match')
			}
			else{
				this.invalidMsg['noMatch'] = null
			}
		},
		wrongPassword(){
			this.invalidMsg['wrongOldPassword'] = this.$t('password.error-desc')
		}
	},
	watch: {
    'model.newPassword': function(value) {
        this.checkPasswordDebounce(this.model.newPassword)
        this.checkRepeatPasswordDebounce(this.model.newPassword, this.model.newPasswordRepeat)
	},
	'model.newPasswordRepeat': function(value) {  
        this.checkRepeatPasswordDebounce(this.model.newPassword, this.model.newPasswordRepeat)
    }
  },
  components:{
	CustomInput
  }
}
</script>

<style lang="less">
#change-password-modal {
	padding: 30px 25px 25px 25px;
	h2 {
		margin: 0;
	}
	form {
		.footer {
			margin-top: 40px;
		}
	}
}



</style>